module.exports = __webpack_public_path__ + "static/media/amazon-rond..778916f8.png";